<!--易询宝询价单列表-->
<template>
    <div
        id="yxbInquires"
        class="business-content-main"
    >
        <div class="bread-nav">
            <div>您当前位置：</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>客服</el-breadcrumb-item>
                <el-breadcrumb-item>询价管理</el-breadcrumb-item>
                <el-breadcrumb-item>易询宝询价单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-name">询价单号:</div>
            <el-input
                style="width: 180px"
                class="search-item"
                size="small"
                v-model.trim="searchData.iCode"
                placeholder="请输入询价单号"
            ></el-input>
            <div class="search-name">客户:</div>
            <el-autocomplete
                class="search-item"
                v-model="searchData.cName"
                :fetch-suggestions="querySearch"
                @select="handleSelect"
                clearable
                placeholder="客户名称"
                size="small"
            ></el-autocomplete>
            <div class="search-name">状态:</div>
            <el-select
                size="small"
                class="search-item"
                v-model="searchData.state"
                placeholder="请选择"
            >
                <el-option
                    v-for="item in orderState"
                    :key="item.Tkey"
                    :label="item.TValue"
                    :value="item.Tkey"
                ></el-option>
            </el-select>
            <div class="search-name">客户意向:</div>
            <el-select
                size="small"
                class="search-item"
                v-model="searchData.intention"
                placeholder="请选择"
            >
                <el-option
                    v-for="item in intentions"
                    :key="item.Tkey"
                    :label="item.TValue"
                    :value="item.Tkey"
                ></el-option>
            </el-select>
            <div class="search-name">询价时间:</div>
            <el-date-picker
                :picker-options="startDateOps"
                class="search-item"
                v-model="searchData.iTimeStart"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                placeholder="选择日期"
            ></el-date-picker>
            <span class="search-name">至</span>
            <el-date-picker
                :picker-options="endDateOps"
                class="search-item"
                v-model="searchData.iTimeEnd"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                placeholder="选择日期"
            ></el-date-picker>

            <el-button
                type="primary"
                size="small"
                icon="el-icon-search"
                class="search-btn"
                @click="handleSearch"
            >查询</el-button>
            <el-button
                type="primary"
                size="small"
                icon="el-icon-refresh"
                class="search-btn"
                @click="resetSearch"
            >重置</el-button>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{background:'#F2F6FC'}"
                :data="tableData"
                border=""
                style="width: 100%"
                @cell-dblclick="handleDBClick"
            >
                <el-table-column
                    width="190px"
                    show-overflow-tooltip
                    prop="ICode"
                    label="单号"
                ></el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="CName"
                    label="客户名称"
                ></el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="ITime"
                    label="询价时间"
                ></el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="NeedTime"
                    label="期限时间"
                ></el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="Remark"
                    label="备注"
                ></el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="Total"
                    label="跟进人"
                ></el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    label="状态"
                >
                    <template slot-scope="scope">{{ scope.row.State|StateHandle }}</template>
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="Intention"
                    label="意向"
                >
                    <template slot-scope="scope">{{ scope.row.Intention==0?"未定":scope.row.Intention==1?"有意向":"无意向"}}</template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                         <el-button
                            type="text"
                            size="small"
                            v-if="permission.编辑&&scope.row.State<= 2&&scope.row.CanEdit"
                            title="编辑报价"
                            @click="goToEdit(scope.row.BillId)"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            size="small"
                            v-if="permission.报价&&scope.row.State== 2"
                            title="报价给客户"
                            @click="quoteToCustomer(scope.row)"
                        >报价</el-button>
                        <el-button
                            type="text"
                            size="small"
                            v-if="permission.推送&&scope.row.Intention>0"
                            title="推送客户意向给企业"
                            @click="submitPurchaseIntention(scope.row)"
                        >推送</el-button>
                        <el-button
                            type="text"
                            size="small"
                            style="color:#e6a23c;"
                            v-if="permission.作废&&(scope.row.State<4)"
                            @click="invalidOrDelInquiryBill(scope.row,'inval')"
                        >作废</el-button>
                        <el-button
                            type="text"
                            size="small"
                            style="color:#f56c6c;"
                            v-if="permission.删除&&(scope.row.State==5)"
                            @click="invalidOrDelInquiryBill(scope.row,'del')"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
  name: "yxbInquires",
  components: {},
  data() {
    return {
      startDateOps: {
        disabledDate: time => {
          return time.getTime() >= Date.now();
        }
      },
      endDateOps: {
        disabledDate: time => {
          return time.getTime() >= Date.now();
        }
      },
      orderState: [
        { Tkey: "-1", TValue: "不限" },
        { Tkey: "0", TValue: "已提交" },
        { Tkey: "1", TValue: "已分发" },
        { Tkey: "2", TValue: "企业已报价" },
        { Tkey: "3", TValue: "已报价给客户" },
        { Tkey: "4", TValue: "已确认客户意向" },
        { Tkey: "5", TValue: "已作废" }
      ],
      intentions: [
        { Tkey: "-1", TValue: "不限" },
        { Tkey: "0", TValue: "未定" },
        { Tkey: "1", TValue: "有意向" },
        { Tkey: "2", TValue: "无意向" }
      ],
      searchData: {
        iCode: "",
        cName: "",
        state: "-1",
        intention: "-1",
        iTimeStart: "",
        iTimeEnd: "",
        page: 1, // 当前页数
        limit: 10 // 每页限制条数
      },
      customerList: [],
      customer: "",
      tableData: [],
      tableDataLength: 0,
      permission: {}
    };
  },
  mounted() {
    this.$util.getPermission("易询宝询价单").then(res => {
      this.permission = res;
    });
    this.getTableData();
  },
  filters: {
    StateHandle(value) {
      let result = "";
      switch (value) {
        case 0:
          result = "已提交";
          break;
        case 1:
          result = "已分发";
          break;
        case 2:
          result = "企业已报价";
          break;
        case 3:
          result = "已报价给客户";
          break;
        case 4:
          result = "已确认客户意向";
          break;
        case 5:
          result = "已作废";
          break;
        default:
          result = "未知";
          break;
      }
      return result;
    }
  },
  methods: {
    getTableData() {
      let that = this;
      this.axios
        .get("/YXBInquiryBill/GetInquiryBillList", {
          params: that.searchData
        })
        .then(response => {
          if (response.data.errcode == 0 && response.data.data) {
            that.tableData = response.data.data;
            that.tableDataLength = response.data.count;
          }else{
            that.tableData = [];
            that.tableDataLength = 0;
          }
        })
        .catch(error => {
          console.log(error);
            that.tableData = [];
            that.tableDataLength = 0;
        });
    },
    quoteToCustomer(item) {
      let that = this;
      this.$util.elConfirm({
        that: this,
        content: "确定要报价给客户?",
        confirm() {
          that.axios
            .post("/YXBInquiryBill/QuoteToCustomer?billId=" + item.BillId)
            .then(response => {
              let result = response.data;
              if (result && result.errcode == 0) {
                item.State = 3;
                that.$message({
                  message: "报价成功",
                  type: "success"
                });
              }
            })
            .catch(error => {
              console.log(error);
              that.$message.error(error.data.errmsg);
            });
        }
      });
    },
    submitPurchaseIntention(item) {
      let that = this;
      this.$util.elConfirm({
        that: this,
        content: "确定要推送客户的购买意向给企业?",
        confirm() {
          that.axios
            .post(
              "/YXBInquiryBill/SubmitPurchaseIntention?billId=" + item.BillId
            )
            .then(response => {
              let result = response.data;
              if (result && result.errcode == 0) {
                item.State = 4;
                that.$message({
                  message: "推送成功",
                  type: "success"
                });
              }
            })
            .catch(error => {
              console.log(error);
              that.$message.error(error.data.errmsg);
            });
        }
      });
    },
    invalidOrDelInquiryBill(item, action) {
      let that = this;
      let url = "/YXBInquiryBill/InvalidInquiryBill?billId=";
      if (action == "del") url = "/YXBInquiryBill/DeleInquiryBill?billId=";
      this.$util.elConfirm({
        that: this,
        content: action == "del" ? "确定要删除询价单?" : "确定要作废询价单?",
        confirm() {
          that.axios
            .post(url + item.BillId)
            .then(response => {
              let result = response.data;
              if (result && result.errcode == 0) {
                if (action == "del") {
                  item.State = 6;
                  let delIndex=that.tableData.findIndex(e=>e.BillId==item.BillId);
                  if(delIndex!=-1){
                    that.tableData.splice(delIndex,1);
                  }
                  that.$message({
                    message: "删除成功",
                    type: "success"
                  });
                } else {
                  item.State = 5;
                  that.$message({
                    message: "作废成功",
                    type: "success"
                  });
                }
              }
            })
            .catch(error => {
              console.log(error);
               that.$message.error(error.data.errmsg);
            });
        }
      });
    },
    querySearch(queryString, cb) {
      let that = this;
    //   that.searchData.cName = "";
      if (!queryString && that.customerList && that.customerList.length > 0) {
        cb(that.customerList);
        return;
      }
      this.searchCustomer(queryString).then(resp => {
        let data = resp.data;
        let customerList = [];
        for (let i in data) {
          customerList.push({
            value: data[i].Name,
            id: data[i].Id
          });
        }
        that.customerList = customerList;
        var results = queryString
          ? customerList.filter(that.createStateFilter(queryString))
          : customerList;
        cb(results);
      });
    },
    createStateFilter(queryString) {
      return state => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect(item) {
    //   this.searchData.cid = item.id;
    },
    searchCustomer(key) {
      return new Promise(resolve => {
        this.axios
          .get("/YXBInquiryBill/GetCustomerList", {
            params: {
              name: key,
              Limit: 10
            },
            hideloading: true
          })
          .then(res => {
            resolve(res.data);
          });
      });
    },
    handleSearch() {
      this.searchData.page = 1;
      this.getTableData();
    },
    resetSearch() {
      this.searchData = {
        iCode: "",
        cName:"",
        state: "-1",
        intention: "-1",
        iTimeStart: "",
        iTimeEnd: "",
        page: 1,
        limit: 10
      };
    },
    handleSizeChange(val) {
      this.searchData.limit = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.searchData.page = val;
      this.getTableData();
    },
    goToEdit(id){
     this.$router.push(
          `/business/inquire/inquiryDeatil?billId=${id}&type=1`
        );
    },
    //表单双击事件
    handleDBClick(event) {
      if (event.BillId) {
        this.$router.push(
          `/business/inquire/inquiryDeatil?billId=${event.BillId}&type=0`
        );
      }
    }
  }
};
</script>
